module.exports = __webpack_public_path__ + "static/media/worker_placeholder.b966b37b.png";